/** Renders completed one-time Activity history and its correction action. */
import type { OneTimeActivity } from '@life-rpg/shared';
import React from 'react';

import { titleCase } from './activityUi.js';

interface CompletedOneTimeActivitiesProps {
  activities: OneTimeActivity[] | null;
  loadFailed: boolean;
  onConvert: (activity: OneTimeActivity) => void;
}

export const CompletedOneTimeActivities = ({
  activities,
  loadFailed,
  onConvert,
}: CompletedOneTimeActivitiesProps): React.JSX.Element => (
  <section aria-labelledby="completed-one-time-activities-heading">
    <h3 id="completed-one-time-activities-heading">Completed</h3>
    {activities === null && !loadFailed && <p>Loading completed activities…</p>}
    {activities?.length === 0 && <p>No completed one-time activities yet.</p>}
    {activities !== null && activities.length > 0 && (
      <ul className="activity-list">
        {activities.map((activity) => (
          <li key={activity.id}>
            <article className="activity-card">
              <h4>{activity.name}</h4>
              <p>{titleCase(activity.difficulty)}</p>
              <button className="secondary" type="button" onClick={() => onConvert(activity)}>
                Make recurring
              </button>
            </article>
          </li>
        ))}
      </ul>
    )}
  </section>
);
